// Generated by purs version 0.14.5
"use strict";
var AllSet = require("../AllSet/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Naporitan = require("../Naporitan/index.js");
var Roles_Types = require("../Roles.Types/index.js");
var TofuJSON = require("../TofuJSON/index.js");
var Types_Classification = require("../Types.Classification/index.js");
var Types_ClassificationGroup = require("../Types.ClassificationGroup/index.js");
var Types_Component = require("../Types.Component/index.js");
var Types_CostClass = require("../Types.CostClass/index.js");
var Types_CostGroup = require("../Types.CostGroup/index.js");
var Types_Element = require("../Types.Element/index.js");
var Types_Estimation = require("../Types.Estimation/index.js");
var Types_Income = require("../Types.Income/index.js");
var Types_Integration = require("../Types.Integration/index.js");
var Types_Invoice = require("../Types.Invoice/index.js");
var Types_JSDateString = require("../Types.JSDateString/index.js");
var Types_JSONString = require("../Types.JSONString/index.js");
var Types_Location = require("../Types.Location/index.js");
var Types_Measurement = require("../Types.Measurement/index.js");
var Types_Newtypes = require("../Types.Newtypes/index.js");
var Types_Organization = require("../Types.Organization/index.js");
var Types_Planning = require("../Types.Planning/index.js");
var Types_Project = require("../Types.Project/index.js");
var Types_Route = require("../Types.Route/index.js");
var Types_Shared = require("../Types.Shared/index.js");
var Types_Unit = require("../Types.Unit/index.js");
var subprojectsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/subprojects";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var subprojectsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/subprojects";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var setUserSSOLoginRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userEmail";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userEmail";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/setUserSSOLogin";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost);
var serverStatus = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(Types_Shared.tofuJSONAppVersion)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(Types_Shared.tofuJSONAppVersion)(TofuJSON.nilWriteForeignFields)()()())()()()))({
    reflectSymbol: function () {
        return "/api/server/status";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet);
var serverRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readMaybe(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readMaybe(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/allUsers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "users";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))({
    reflectSymbol: function () {
        return "/api/userOrganizations";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "userOrganizations";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/setUserOrganizations";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateUserOrganizations";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplier";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplier";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/supplier";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateSupplier";
    }
}))()()(Types_Route.routeReflectProxy(Roles_Types.tofuJSONUserRole)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/role/:roleId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.writeUserRoleId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateRole";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/updateProjectGroupCache";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateProjectGroupCache";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/updated-portfolio-report";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "updatePortfolioReport";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementUnitId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementUnitId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/measurements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateMeasurementValue";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/costControlSocialExpenses/:projectId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateCostControlSocialExpenses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupItemAssociationId";
    }
})(Types_CostGroup.tofuJSONCostGroupItemAssociationId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isGenerated";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "modifierEmail";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "modifyDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupItemAssociationId";
    }
})(Types_CostGroup.tofuJSONCostGroupItemAssociationId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isGenerated";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "modifierEmail";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "modifyDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/targetItems";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "targetItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/suppliers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "suppliers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimateSocialExpensePercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetSocialExpensePercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetSocialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimateSocialExpensePercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetSocialExpensePercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetSocialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/socialExpenses";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "socialExpenses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "roleAssignments";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "roleAssignments";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/setUserRoles";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setUserRoles";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superadmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superadmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/superadmin/setSuperadmin";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setSuperadmin";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/server/outageMessage";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setOutageMessage";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "adminetTenantId";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONAdminetTenantId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "cognitoIdentityProviderName";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONCognitoIdentityProviderName))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "quotas";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "adminetTenantId";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONAdminetTenantId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "cognitoIdentityProviderName";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONCognitoIdentityProviderName))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "quotas";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/quotas/:organization";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.writeParamOrganization)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setOrganizationQuotas";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlExcludeActualCostSocialExpenses";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlExcludeActualCostSocialExpenses";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/set_cost_control_exclude_actual_cost_social_expenses";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setCostControlExcludeActualCostSocialExpenses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(Types_Shared.tofuJSONAppVersion)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "outageMessage";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(Types_Shared.tofuJSONAppVersion)(TofuJSON.nilWriteForeignFields)()()())()()()))({
    reflectSymbol: function () {
        return "/api/server/status";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "serverStatus";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "role";
    }
})(Roles_Types.tofuJSONUserRole)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "role";
    }
})(Roles_Types.tofuJSONUserRole)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/role";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "roles";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroups";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projects";
    }
})(TofuJSON.readArray(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.tofuJSONUserRoleId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userId";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/roleAssignments";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "roleAssignments";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONCompanyName))({
    reflectSymbol: function () {
        return "/api/responsibilityCompanies";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "responsibilityCompanies";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_CostGroup.tofuJSONReportingResource))({
    reflectSymbol: function () {
        return "/api/project/:projectId/reportingResources";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "reportingResources";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Component.tofuJSONReportingComponent))({
    reflectSymbol: function () {
        return "/api/project/:projectId/reportingComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "reportingComponents";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lastUpdated";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lastUpdated";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/projectGroupCacheLastUpdate";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectGroupCacheLastUpdate";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/portfolio-report";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "portfolioReport";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readMaybe(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userCapabilities";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ccReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ccWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ceReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ceWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlPermission";
    }
})(Roles_Types.tofuJSONCostControlPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costEstimationPermission";
    }
})(Roles_Types.tofuJSONCostEstimationPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupTargetWritePermission";
    }
})(Roles_Types.tofuJSONWriteCostGroupTargetPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createProjectsPermission";
    }
})(Roles_Types.tofuJSONCreateProjectsPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isAdmin";
    }
})(Roles_Types.tofuJSONIsOrganizationAdmin)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ccReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ccWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ceReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ceWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlPermission";
    }
})(Roles_Types.tofuJSONCostControlPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costEstimationPermission";
    }
})(Roles_Types.tofuJSONCostEstimationPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupTargetWritePermission";
    }
})(Roles_Types.tofuJSONWriteCostGroupTargetPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createProjectsPermission";
    }
})(Roles_Types.tofuJSONCreateProjectsPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isAdmin";
    }
})(Roles_Types.tofuJSONIsOrganizationAdmin)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readMaybe(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Organization.tofuJSONUserId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organizations";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userCapabilities";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ccReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ccWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ceReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ceWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlPermission";
    }
})(Roles_Types.tofuJSONCostControlPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costEstimationPermission";
    }
})(Roles_Types.tofuJSONCostEstimationPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupTargetWritePermission";
    }
})(Roles_Types.tofuJSONWriteCostGroupTargetPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createProjectsPermission";
    }
})(Roles_Types.tofuJSONCreateProjectsPermission)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isAdmin";
    }
})(Roles_Types.tofuJSONIsOrganizationAdmin)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ccReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ccWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ceReadableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ceWritableProjects";
    }
})(AllSet.tofujsonAllSLet(Types_Project.ordProjectId)(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlPermission";
    }
})(Roles_Types.tofuJSONCostControlPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costEstimationPermission";
    }
})(Roles_Types.tofuJSONCostEstimationPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupTargetWritePermission";
    }
})(Roles_Types.tofuJSONWriteCostGroupTargetPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createProjectsPermission";
    }
})(Roles_Types.tofuJSONCreateProjectsPermission)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isAdmin";
    }
})(Roles_Types.tofuJSONIsOrganizationAdmin)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/users";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "organizationUsers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userIds";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONUserId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userIds";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONUserId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/orgUsers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "orgRemoveUsers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgMeasurementId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgMeasurementId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/measurements";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgMeasurements";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/orgCostClasses";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgCostClasses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readString))({
    reflectSymbol: function () {
        return "/api/orgAddressArea";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgAddressArea";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSO";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSO";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.readArray(Types_Organization.tofuJSONUserId))({
    reflectSymbol: function () {
        return "/api/orgAddUsers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "orgAddUsers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(Types_Newtypes.tofuJSONMeasurementUnitId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/measurements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "measurements";
    }
}))()()(Types_Route.routeReflectProxy(Types_Measurement.tofuJSONMeasurementUnitAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/measurementUnitAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "measurementUnitAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "action";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "body";
    }
})(Types_JSONString.tofuJSONJSONString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "text";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "action";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "body";
    }
})(Types_JSONString.tofuJSONJSONString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "text";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/logs";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "logs";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "admin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControl";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "integration";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "admin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControl";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimation";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "integration";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/appAccessRights";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "getUserAppAccessRights";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(Types_Organization.tofuJSONQuotaUsage)({
    reflectSymbol: function () {
        return "/api/admin/quotas";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "getOrganizationQuotaUsage";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "adminetTenantId";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONAdminetTenantId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "cognitoIdentityProviderName";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONCognitoIdentityProviderName))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "quotas";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "adminetTenantId";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONAdminetTenantId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "cognitoIdentityProviderName";
    }
})(TofuJSON.readMaybe(Types_Organization.tofuJSONCognitoIdentityProviderName))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "quotas";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationRWUsers";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationUsers";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/quotas";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "getAllOrganizationQuotas";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONFinancingType))({
    reflectSymbol: function () {
        return "/api/financingTypes";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "financingTypes";
    }
}))()()(Types_Route.routeReflectProxy(Types_Integration.tofuJSONFetchDataFromIntegration)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/fetchDataFromIntegration";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "fetchDataFromIntegration";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupItemAssociationId";
    }
})(Types_CostGroup.tofuJSONCostGroupItemAssociationId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isGenerated";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "modifierEmail";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "modifyDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupItemAssociationId";
    }
})(Types_CostGroup.tofuJSONCostGroupItemAssociationId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isGenerated";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "modifierEmail";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "modifyDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimateItems";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "estimateItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userIds";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONUserId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userIds";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONUserId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/users";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteUsers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/role/:roleId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "roleId";
    }
})(Roles_Types.writeUserRoleId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteRole";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())))({
    reflectSymbol: function () {
        return "/api/defaultClassification";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "defaultClassification";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "plan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "plan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.nilWriteForeignFields)()()())()()()))({
    reflectSymbol: function () {
        return "/api/currentOrganization";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "currentOrganization";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/cost-group-classifications";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroupClassifications";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costClasses";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costClasses";
    }
}))()()(Types_Route.routeReflectProxy(Types_CostClass.tofuJSONCostClassAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassIds";
    }
})(TofuJSON.readArray(Types_CostClass.tofuJSONCostClassId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassIds";
    }
})(TofuJSON.readArray(Types_CostClass.tofuJSONCostClassId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costClassAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "costClassAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONContractType))({
    reflectSymbol: function () {
        return "/api/contractTypes";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "contractTypes";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONConstructionType))({
    reflectSymbol: function () {
        return "/api/constructionTypes";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "constructionTypes";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())))({
    reflectSymbol: function () {
        return "/api/classifications";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "classifications";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/changeOrganization";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "changeOrganization";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))({
    reflectSymbol: function () {
        return "/api/allOrganizations";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "allOrganizations";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgs";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgs";
    }
})(TofuJSON.readArray(Types_Organization.tofuJSONOrganization))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userData";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "email";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSOLogin";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "org";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPlan";
    }
})(Types_Organization.tofuJSONPlan)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "superAdmin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readArray(Types_Organization.tofuJSONUserId))({
    reflectSymbol: function () {
        return "/api/addUsers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addUsers";
    }
}))()()(Types_Route.routeReflectProxy(Roles_Types.tofuJSONUserRole)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "roleId";
    }
})(TofuJSON.readMaybe(Roles_Types.tofuJSONUserRoleId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "roleId";
    }
})(TofuJSON.readMaybe(Roles_Types.tofuJSONUserRoleId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/role";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addRole";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "database";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "password";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "database";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "password";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/organizations/:organization";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.writeParamOrganization)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addOrganization";
    }
})));
var referenceSubprojectsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceSubprojects";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceSubprojectsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceSubprojects";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationResourcesRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationResources";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationResourcesRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationResources";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationLocationsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationLocationsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amountSource";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createTime";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementSpecId";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONElementSpecId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationLocationId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "locationCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amountSource";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createTime";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementSpecId";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONElementSpecId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationLocationId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "locationCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationElementsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationElements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationElementsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElement))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationElements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationComponentsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceEstimationComponentsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceEstimationComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceElementSpecsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceElementSpecs";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceElementSpecsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElementSpec))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceElementSpecs";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceElementLocationsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceElementLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var referenceElementLocationsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElementLocation))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceElementLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var projectRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONShouldUpdateBusinessId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "companyName";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyName))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectRole";
    }
})(Types_Project.tofuJSONProjectRoleId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONShouldUpdateBusinessId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "companyName";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyName))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectRole";
    }
})(Types_Project.tofuJSONProjectRoleId)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/projectResponsibilityInfo/:projectId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateProjectResponsibilityInfo";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementUnits";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementUnits";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/projectForm";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateProjectForm";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(Types_Project.tofuJSONApplicationMode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectVersion";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "setArchived";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(Types_Project.tofuJSONApplicationMode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectVersion";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "setArchived";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/updateArchiveStatus";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateProjectArchiveStatus";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "body";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "body";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/update";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/reporting/unpublish";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "unpublishReportingEstimationProject";
    }
}))()()(Types_Route.routeReflectProxy(Types_Project.tofuJSONSubprojectAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/subprojectAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "subprojectAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "dryRun";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceMultiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "dryRun";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceMultiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceDifference";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceDifference";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/price-adjustment";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "resourcePriceAdjustment";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/ResetTargetItems";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "resetCostGroupTargetItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostClass.tofuJSONCostClassId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForComponents";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForEstimatesAndActuals";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostControlForTargets";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/referenceProjectCostClasses";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "referenceProjectCostClasses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/reporting/publish";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "publishEstimationProjectToReporting";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONProjectType))({
    reflectSymbol: function () {
        return "/api/projectTypes";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectTypes";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "businessId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONBusinessId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "companyId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "companyName";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyName))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectRole";
    }
})(Types_Project.tofuJSONProjectRoleId)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "businessId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONBusinessId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "companyId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "companyName";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONCompanyName))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectRole";
    }
})(Types_Project.tofuJSONProjectRoleId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/projectResponsibilityInfo/:projectId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectResponsibilityInfo";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Location.tofuJSONProjectLocation))({
    reflectSymbol: function () {
        return "/api/project/:projectId/projectLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectLocations";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONProjectGroup))({
    reflectSymbol: function () {
        return "/api/projectGroups";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Classification.tofuJSONProjectClassificationClass))({
    reflectSymbol: function () {
        return "/api/project/:projectId/projectClassificationClasses";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectClassificationClasses";
    }
}))()()(Types_Route.routeReflectProxy(Types_Classification.tofuJSONProjectClassificationClassAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectClassificationClassId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONProjectClassificationClassId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectClassificationClassId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONProjectClassificationClassId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/projectClassificationClassAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "projectClassificationClassAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualDiffApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualIncomeApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualMarginApproved";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(Types_Project.tofuJSONCurrency)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultInvoiceCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "defaultSalaryCostClass";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownTaxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetDiff";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetIncome";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetMargin";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(Types_Unit.tofuJSONTaxrate))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "project";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Classification.tofuJSONOrgClassificationClass))({
    reflectSymbol: function () {
        return "/api/project/:projectId/orgClassificationClasses";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgClassificationClasses";
    }
}))()()(Types_Route.routeReflectProxy(Types_Location.tofuJSONLocationAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectLocationId";
    }
})(TofuJSON.readMaybe(Types_Location.tofuJSONProjectLocationId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectLocationId";
    }
})(TofuJSON.readMaybe(Types_Location.tofuJSONProjectLocationId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/locationAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "locationAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONProjectManager))({
    reflectSymbol: function () {
        return "/api/getProjectManagers";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "getProjectManagers";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Project.tofuJSONCurrency))({
    reflectSymbol: function () {
        return "/api/project/:projectId/exchangeRateCurrencies";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "exchangeRateCurrencies";
    }
}))()()(Types_Route.routeReflectProxy(Types_Element.tofuJSONElementMeasureAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementMeasureAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "elementMeasureAction";
    }
}))()()(Types_Route.routeReflectProxy(Types_Element.tofuJSONElementAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "elementAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "newPM";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "oldPM";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "newPM";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "oldPM";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.nilWriteForeignFields)()()())()()()))(Types_Project.tofuJSONPMAdd)({
    reflectSymbol: function () {
        return "/api/editProjectManager";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "editProjectManager";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "refProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "refProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/deleteReferenceProject";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "deleteReferenceProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pm";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pm";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.nilWriteForeignFields)()()()))(Types_Project.tofuJSONPMDel)({
    reflectSymbol: function () {
        return "/api/deleteProjectManager";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "deleteProjectManager";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "groupCodes";
    }
})(TofuJSON.readArray(TofuJSON.readString))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "groupCodes";
    }
})(TofuJSON.readArray(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/classificationGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteClassificationGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/cost-control";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costControlProjects";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sourceProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sourceProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/copyProject";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "copyProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_ClassificationGroup.tofuJSONClassificationGroup))({
    reflectSymbol: function () {
        return "/api/project/:projectId/classificationGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "classificationGroups";
    }
}))()()(Types_Route.routeReflectProxy(Types_ClassificationGroup.tofuJSONClassificationGroupAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classificationGroupId";
    }
})(TofuJSON.readMaybe(Types_ClassificationGroup.tofuJSONClassificationGroupId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classificationGroupId";
    }
})(TofuJSON.readMaybe(Types_ClassificationGroup.tofuJSONClassificationGroupId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/classificationGroupAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "classificationGroupAction";
    }
}))()()(Types_Route.routeReflectProxy(Types_Project.tofuJSONAllocateToProject)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/allocateImportInvoiceToProject";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "allocateToProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/all-projects";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "allProjects";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "refProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "refProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/addReferenceProject";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addReferenceProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pm";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pm";
    }
})(Types_Project.tofuJSONProjectManager)(TofuJSON.nilWriteForeignFields)()()()))(Types_Project.tofuJSONPMAdd)({
    reflectSymbol: function () {
        return "/api/addProjectManager";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addProjectManager";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupClassification";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementUnits";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hourlyPricing";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensePercentageInCostEstimation";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupClassification";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementUnits";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mandatory";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "values";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Newtypes.tofuJSONMeasurementValueId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurementId";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONMeasurementUnitId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/projectForm";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addProjectForm";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "body";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "copyCostGroupsFromProject";
    }
})(Types_Project.tofuJSONCopyCostGroupsFromProject)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "enableCostControl";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "enableEstimation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "body";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "address";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "city";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classification";
    }
})(Types_Classification.tofuJSONOrgClassificationCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "constructionType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractPrice";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contractType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "endDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "financingType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "postalCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectManager";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectType";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "startDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "copyCostGroupsFromProject";
    }
})(Types_Project.tofuJSONCopyCostGroupsFromProject)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "enableCostControl";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "enableEstimation";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addProject";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "groupData";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "groupData";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/classificationGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addClassificationGroups";
    }
})));
var planningRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementCostGroupConnections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupConnectionId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupConnectionId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostGroupClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCostGroupClassification";
    }
})(TofuJSON.readMaybe(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classificationName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classificationName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementCostGroupConnections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupConnectionId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupConnectionId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostGroupClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgClassificationId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCostGroupClassification";
    }
})(TofuJSON.readMaybe(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classificationName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classificationName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCostGroupClassificationId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/projectCostGroupClassificationInfo";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "projectCostGroupClassificationInfo";
    }
}))()()(Types_Route.routeReflectProxy(Types_Planning.tofuJSONPlanningAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/planningAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "planningAction";
    }
})));
var planningCostGroupsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/planningCostGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var planningCostGroupsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupClassificationId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupClassificationId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/planningCostGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var organizationAdminInfoRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hasSSO";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hasSSO";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization";
    }
})(Types_Organization.tofuJSONOrganization)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sendInvitation";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/organizationAdminInfo";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet);
var offerRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/setOfferPageParams";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setOfferPageParams";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/setOfferPageParams";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "getOfferPageParams";
    }
})));
var invoicesRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClass";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(TofuJSON.readNullable(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(Types_Invoice.tofuJSONInvoiceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "quantity";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplierInvoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "type";
    }
})(Types_Invoice.tofuJSONInvoiceType)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClass";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(TofuJSON.readNullable(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(Types_Invoice.tofuJSONInvoiceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "quantity";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplierInvoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "type";
    }
})(Types_Invoice.tofuJSONInvoiceType)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var invoiceRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceLineIds";
    }
})(TofuJSON.readArray(Types_Invoice.tofuJSONInvoiceRowId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceLineIds";
    }
})(TofuJSON.readArray(Types_Invoice.tofuJSONInvoiceRowId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoices/costGroup/:encodedCostGroupCode";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "encodedCostGroupCode";
    }
})(Types_CostGroup.writeParamCostGroupCode)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateInvoiceLinesCostGroup";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceLineIds";
    }
})(TofuJSON.readArray(Types_Invoice.tofuJSONInvoiceRowId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceLineIds";
    }
})(TofuJSON.readArray(Types_Invoice.tofuJSONInvoiceRowId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoices/costClass/:costClassCode";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.writeParamCostClassCode)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateInvoiceLinesCostClass";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoice/:invoiceLineId";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "invoiceLineId";
    }
})(Types_Invoice.writeParamInvoiceRowId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateInvoiceLineCostGroup";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "optionalNewInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updates";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceLineId";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "optionalInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceLineId";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "optionalInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "optionalNewInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updates";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceLineId";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "optionalInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceLineId";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "optionalInvoiceBunchId";
    }
})(TofuJSON.readMaybe(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/updateInvoiceLineBunches";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateInvoiceLineBunches";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeItemCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONSalesInvoiceId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeItemCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONSalesInvoiceId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/salesInvoice";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateCodeForSalesInvoice";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income/PlannedInvoiceDate";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setIncomeItemPlannedInvoiceDates";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONSalesInvoiceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "valueWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONSalesInvoiceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "valueWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/salesInvoices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "salesInvoices";
    }
}))()()(Types_Route.routeReflectProxy(Types_Invoice.tofuJSONMigrateInvoices)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/migrateSelectedInvoices";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "migrateSelectedInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "file";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "file";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readString)({
    reflectSymbol: function () {
        return "/api/getInvoiceImg/";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "invoiceImg";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "bunchDate";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "bunchDate";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoiceBunches";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "invoiceBunches";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "insertSupplier";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "label";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplier";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "type";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "businessId";
    }
})(Types_Project.tofuJSONBusinessId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "insertSupplier";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "label";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplier";
    }
})(Types_Project.tofuJSONSupplier)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "type";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/insertInvoice";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "insertInvoice";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "dueDate";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lines";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "dueDate";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lines";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readMaybe(Types_Income.tofuJSONIncomeItemCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/mportSalesInvoices";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "importSalesInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "externalId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "image";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isSalary";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lines";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readMaybe(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updatedAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readMaybe(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updatedAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "voucherNumber";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "externalId";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "image";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isSalary";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lines";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readMaybe(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updatedAt";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readMaybe(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readMaybe(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "exportDate";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineNumber";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "netSum";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(TofuJSON.readMaybe(Types_Project.tofuJSONProjectCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updatedAt";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vatPercent";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "voucherNumber";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/importInvoices";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "importInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ids";
    }
})(TofuJSON.readArray(Types_Income.tofuJSONSalesInvoiceId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ids";
    }
})(TofuJSON.readArray(Types_Income.tofuJSONSalesInvoiceId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/deleteSalesInvoices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "deleteSalesInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(Types_Invoice.tofuJSONInvoiceRowId))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoiceBunches";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteInvoiceBunch";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/invoiceBunches";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "createInvoiceBunch";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClass";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(TofuJSON.readNullable(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(Types_Invoice.tofuJSONInvoiceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "quantity";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "socialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "supplierInvoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "type";
    }
})(Types_Invoice.tofuJSONInvoiceType)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClass";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "hours";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Invoice.tofuJSONInvoiceRowId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(TofuJSON.readNullable(Types_Invoice.tofuJSONInvoiceBunchId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceId";
    }
})(Types_Invoice.tofuJSONInvoiceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceImg";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "lineDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "quantity";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "socialExpensesPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplier";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplierBusinessId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "supplierInvoiceNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "type";
    }
})(Types_Invoice.tofuJSONInvoiceType)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroup/:costGroupId/invoices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costGroupId";
    }
})(Types_CostGroup.writeParamCostGroupId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroupInvoices";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "bunchDate";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "bunchDate";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "invoiceBunchId";
    }
})(Types_Invoice.tofuJSONInvoiceBunchId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectCode";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/allInvoiceBunches";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "allInvoiceBunches";
    }
})));
var incomeRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(Types_Income.tofuJSONUpdateIncomeItem)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income/update";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateIncomeItem";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isIncludedInTarget";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isIncludedInTarget";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income/inclusionInTarget";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setIncomeItemsInclusionInTarget";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isApproved";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isApproved";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income/approvalStatus";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setIncomeItemApprovalStatuses";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "date";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income/approvalDate";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "setIncomeItemApprovalDates";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemId";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.nilWriteForeignFields)()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "removeIncomeItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amountPaid";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "dateOfApproval";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "groupName";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "importDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isApproved";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isIncludedInTarget";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "plannedInvoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(Types_Unit.tofuJSONTaxrate))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "valueWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amountPaid";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "dateOfApproval";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "groupName";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "importDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isApproved";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isIncludedInTarget";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "plannedInvoiceDate";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(Types_Unit.tofuJSONTaxrate))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "valueWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "incomeItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Income.tofuJSONIncomeItemId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/incomeGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "incomeGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "dueDate";
    }
})(Types_JSDateString.tofuJSONJSDateString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sumWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "dueDate";
    }
})(Types_JSDateString.tofuJSONJSDateString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "incomeItemCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sumWithoutVAT";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/income";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addIncomeItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Income.tofuJSONIncomeGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(Types_Income.tofuJSONIncomeGroupName)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/addIncomeGroup";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addIncomeGroup";
    }
})));
var exportProjectToFileRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcClassificationGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AluekorjausHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CalculateWithPercent";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CoverGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ehto";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "IncludeVAT";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "IndeksiHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Lukittu";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutKustannuksetHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "NaytaRakennusosalaskelmassa";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjectAreaGroup_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProsArvio";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SummaSyotetty";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Valuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AluekorjausHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CalculateWithPercent";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CoverGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ehto";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "IncludeVAT";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "IndeksiHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Lukittu";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutKustannuksetHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "NaytaRakennusosalaskelmassa";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjectAreaGroup_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProsArvio";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SummaSyotetty";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Valuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcComponentLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MRSijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MRSijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcComponents";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Alkupera";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ErittelyTunnukset";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MalliSuorite";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Merkitty";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuistiLappuTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osakoodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Yksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Alkupera";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ErittelyTunnukset";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MalliSuorite";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Merkitty";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuistiLappuTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osakoodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Yksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcCostClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kateprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosvarausEiKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosvarausKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nousuvaraus";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RiskiProsentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TakSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TarkkailuSosiaalikulu";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavoitesarakeMkTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavoitesarakeTuntiTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TyoKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleisKulutprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kateprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosvarausEiKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosvarausKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nousuvaraus";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RiskiProsentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TakSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TarkkailuSosiaalikulu";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavoitesarakeMkTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavoitesarakeTuntiTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TyoKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleisKulutprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcCostGroupConnections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ConnectType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraConnect_ID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MRPanos_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ConnectType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraConnect_ID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MRPanos_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcCurrencies";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kurssi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Valuuttakurssi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kurssi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Valuuttakurssi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonDrawingScales";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "height_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "width_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "height_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "width_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonDrawings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "file_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "prev_revision";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "rotation";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "file_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "prev_revision";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "rotation";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonFiles";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "archived";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "kind";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "s3_key";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "archived";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "kind";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "s3_key";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonMeasurementGroupLinks";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "building_element_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "component_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "element_spec_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "from_type";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "target_field";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "building_element_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "component_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "element_spec_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "from_type";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "target_field";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonMeasurementGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "color";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "color";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcDixonMeasurements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "formula";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "formula_result";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "location";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "num_vertices";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "perimeter";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "formula";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "formula_result";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "location";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "num_vertices";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "perimeter";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcElementLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RASijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RASijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcElementMeasures";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakenneMitta_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakenneMitta_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcElementSpecs";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kaava";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kaava";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcElements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "GroupFlag";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kommentti";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LastZoom";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RTKoodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RTSelite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Yks";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "GroupFlag";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kommentti";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LastZoom";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RTKoodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RTSelite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Yks";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcMeasurementValues";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LaajuusTieto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TOTArvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LaajuusTieto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TOTArvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcMeasurements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Pakollinen";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ROLLaajuusTieto";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Pakollinen";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ROLLaajuusTieto";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcOfferPageParams";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcPlanningCostGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraNimikkeisto";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "NimikkeistoTyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraNimikkeisto";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "NimikkeistoTyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcProjectCostGroupClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcProjectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Area";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LaskentaValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "OletusValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "OmaKohde";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osoite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Pohjakurssivaluutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PostiNumero";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PostiToimiPaikka";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projektitunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rahoitusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakennusAikaAlkaa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakennusAikaPaattyy";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SalaSana";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TarjousLaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tarkkailulaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tilanne";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Toteutusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UrakkaSumma";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Versio";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleHankeTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleProjektiRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleRakennusTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleVastuuHenkilo_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Area";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LaskentaValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "OletusValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "OmaKohde";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osoite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Pohjakurssivaluutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PostiNumero";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PostiToimiPaikka";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projektitunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rahoitusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakennusAikaAlkaa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakennusAikaPaattyy";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SalaSana";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TarjousLaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tarkkailulaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tilanne";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Toteutusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UrakkaSumma";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Versio";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleHankeTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleProjektiRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleRakennusTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleVastuuHenkilo_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcResources";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlePros";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ContractArea";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ContractCategory";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "EANKoodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HinnoiteltuPanoksilla";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Hinta";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HintaLukittu";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HukkaPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Indeksi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kiintea";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KustannusLaji_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraKohdistusPanos";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosPvm";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiEranNettoSisalto";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiEranYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi1";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi2";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PriceSource";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RowCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sopimus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Source";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TSPercent";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ToimittajaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ValuuttaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Voimassa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Weblink";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosAlaRyhma_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosAlennusRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosHinnasto_OmaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosHinnasto_YID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePriceList_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleToimittaja_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlePros";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ContractArea";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ContractCategory";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "EANKoodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HinnoiteltuPanoksilla";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Hinta";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HintaLukittu";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HukkaPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Indeksi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kiintea";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KustannusLaji_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraKohdistusPanos";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosPvm";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiEranNettoSisalto";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiEranYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi1";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi2";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PriceSource";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RowCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sopimus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Source";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TSPercent";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ToimittajaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ValuuttaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Voimassa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Weblink";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosAlaRyhma_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosAlennusRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosHinnasto_OmaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosHinnasto_YID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePriceList_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleToimittaja_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "srcSubprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MukanaLaajuusTiedoissa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MukanaLaajuusTiedoissa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcClassificationGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AluekorjausHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CalculateWithPercent";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CoverGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ehto";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "IncludeVAT";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "IndeksiHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Lukittu";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutKustannuksetHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "NaytaRakennusosalaskelmassa";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjectAreaGroup_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProsArvio";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SummaSyotetty";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Valuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AluekorjausHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CalculateWithPercent";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CoverGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ehto";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "IncludeVAT";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "IndeksiHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Lukittu";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutKustannuksetHuomioi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "NaytaRakennusosalaskelmassa";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjectAreaGroup_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProsArvio";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SummaSyotetty";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Valuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcComponentLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MRSijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MRSijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcComponents";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Alkupera";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ErittelyTunnukset";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MalliSuorite";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Merkitty";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuistiLappuTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osakoodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Yksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Alkupera";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ErittelyTunnukset";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MalliSuorite";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Merkitty";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuistiLappuTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osakoodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tyyppi";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Yksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcCostClasses";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kateprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosvarausEiKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosvarausKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nousuvaraus";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RiskiProsentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TakSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TarkkailuSosiaalikulu";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavoitesarakeMkTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TavoitesarakeTuntiTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TyoKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleisKulutprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kateprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosvarausEiKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosvarausKiinteatPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nousuvaraus";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RiskiProsentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TakSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TarkkailuSosiaalikulu";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavSosiaaliKuluPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavoitesarakeMkTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TavoitesarakeTuntiTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TyoKasittely";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleisKulutprosentti";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcCostGroupConnections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ConnectType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraConnect_ID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MRPanos_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ConnectType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraConnect_ID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MRPanos_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tila_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcCurrencies";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kurssi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Valuuttakurssi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kurssi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Valuuttakurssi_ID";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonDrawingScales";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "height_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "width_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "height_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "width_meters";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonDrawings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "file_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "prev_revision";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "rotation";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "file_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "prev_revision";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "rotation";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonFiles";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "archived";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "kind";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "s3_key";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "archived";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "kind";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "s3_key";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonMeasurementGroupLinks";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "building_element_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "component_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "element_spec_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "from_type";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "target_field";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "building_element_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "component_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "element_spec_id";
    }
})(TofuJSON.readMaybe(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "from_type";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "target_field";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonMeasurementGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "color";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "color";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_formula";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "default_location";
    }
})(TofuJSON.readMaybe(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "organization_id";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "project_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcDixonMeasurements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "formula";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "formula_result";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "location";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "num_vertices";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "perimeter";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "area";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "drawing_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "formula";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "formula_result";
    }
})(TofuJSON.readMaybe(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "location";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "measurement_group_id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "num_vertices";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "perimeter";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "shape";
    }
})(TofuJSON.tofuJSONForeign)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcElementLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RASijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KalusteVaruste_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Maara";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osamitta_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RASijainti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sijainti_Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcElementMeasures";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakenneMitta_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakenneMitta_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcElementSpecs";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kaava";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kaava";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraLahde";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RaErittely_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcElements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "GroupFlag";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kommentti";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LastZoom";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RTKoodi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RTSelite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Yks";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AikaLeima";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ArchiCAD";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "CreateTime";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "External_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ExtraID";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "GroupFlag";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kommentti";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Koodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LastZoom";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RTKoodi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RTSelite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rakenne_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UserName";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Yks";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcLocations";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcMeasurementValues";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LaajuusTieto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TOTArvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlaKohde_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Arvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LaajuusTieto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TOTArvo";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcMeasurements";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Pakollinen";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ROLLaajuusTieto";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Pakollinen";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ROLLaajuusTieto";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcOfferPageParams";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "marginPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "offerOverrides";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "riskPercentages";
    }
})(TofuJSON.tofuJSONMap(Data_Ord.ordString)(TofuJSON.readString)(Types_Unit.tofuJSONPercentageOfZeroToOne))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "showEconomicMargin";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcPlanningCostGroups";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraNimikkeisto";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "NimikkeistoTyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraNimikkeisto";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "NimikkeistoTyyppi";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcProjectCostGroupClassifications";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ProjektiLitteraNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Selite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcProjectDetails";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Area";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LaskentaValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "OletusValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "OmaKohde";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Osoite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Pohjakurssivaluutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PostiNumero";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PostiToimiPaikka";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projektitunnus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Rahoitusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakennusAikaAlkaa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RakennusAikaPaattyy";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "SalaSana";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TarjousLaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tarkkailulaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tilanne";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Toteutusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "UrakkaSumma";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Versio";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleHankeTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleProjektiRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleRakennusTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleVastuuHenkilo_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Area";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LaskentaValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "OletusValuutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "OmaKohde";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Osoite";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Pohjakurssivaluutta";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PostiNumero";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PostiToimiPaikka";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projektitunnus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Rahoitusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakennusAikaAlkaa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RakennusAikaPaattyy";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "SalaSana";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TarjousLaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tarkkailulaskenta";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tilanne";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Toteutusmuoto";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "UrakkaSumma";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Versio";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleHankeTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleNimikkeisto_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleProjektiRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleRakennusTyyppi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleVastuuHenkilo_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcResources";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlePros";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ContractArea";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ContractCategory";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "EANKoodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HinnoiteltuPanoksilla";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Hinta";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HintaLukittu";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "HukkaPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Indeksi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Kiintea";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "KustannusLaji_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "LitteraKohdistusPanos";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MuutosPvm";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiEranNettoSisalto";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiEranYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MyyntiYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi1";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi2";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "PriceSource";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "RowCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Sopimus";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Source";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "TSPercent";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ToimittajaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ValuuttaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Voimassa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Weblink";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosAlaRyhma_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosAlennusRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosHinnasto_OmaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePanosHinnasto_YID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YlePriceList_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "YleToimittaja_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlePros";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "AlvPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ContractArea";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ContractCategory";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "EANKoodi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HinnoiteltuPanoksilla";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Hinta";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HintaLukittu";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "HukkaPros";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Indeksi";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "JarjestysNro";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kerroin";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Kiintea";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "KustannusLaji_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Littera";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "LitteraKohdistusPanos";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MaaraRivi_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Menekki";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MuutosPvm";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiEranNettoSisalto";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiEranYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MyyntiYksikko";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi1";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi2";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "PriceSource";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "RowCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Ryhma";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Sopimus";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Source";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Summa";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "TSPercent";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ToimittajaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ValuuttaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Voimassa";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Weblink";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosAlaRyhma_Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosAlennusRyhma_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosHinnasto_OmaTunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePanosHinnasto_YID";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YlePriceList_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "YleToimittaja_ID";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "srcSubprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "MukanaLaajuusTiedoissa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Muistio";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "MukanaLaajuusTiedoissa";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Nimi";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Projekti_ID";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "Tunnus";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/exportProjectToFile";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationResource";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationResource";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResource/:estimationResourceId/price";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "estimationResourceId";
    }
})(Types_Component.writeParamEstimationResourceId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateEstimationResourcePrice";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memoValue";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memoValue";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/updateEstimationComponentMemo";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateEstimationComponentMemo";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updateSelections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updateSourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updateSourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updateSelections";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "updateSourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "updateSourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.nilWriteForeignFields)()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResourcePriceUpdate";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "projectResourcePriceUpdateFromPricelist";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "matchingRule";
    }
})(Types_Estimation.tofuJSONMatchingRules)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricelistName";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONEstimationResourceId))(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "matchingRule";
    }
})(Types_Estimation.tofuJSONMatchingRules)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricelistName";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONEstimationResourceId))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "matchingPrices";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "matchingPrices";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceId";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResourcePriceMatch";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "projectResourcePriceMatch";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/orgPriceLists";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgPriceLists";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "groupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGrouping";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subgroupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGrouping";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subgroupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceList";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "groupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGrouping";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subgroupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGrouping";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "associatedOrgCostClassIds";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgCostClassId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()()))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subgroupings";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceGroupingId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourceSubGroupingParentCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())))(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceList";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgPriceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/orgPriceListTree";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "orgPriceListTree";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationResource";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationResource";
    }
})(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()()))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationComponent/:estimationComponentId/costClass/:costClassCode/price";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.writeParamCostClassCode)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(Types_Component.writeParamComponentId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "insertEstimationComponentCostClassPrice";
    }
}))()()(Types_Route.routeReflectProxy(Types_Estimation.tofuJSONEstimationResourcePriceListAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/orgResourcePrices";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "estimationResourcePriceListAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actionParams";
    }
})(Types_Estimation.tofuJSONEstimationResourceActionParams)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actionType";
    }
})(Types_Estimation.tofuJSONTargetComponentAction)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actionParams";
    }
})(Types_Estimation.tofuJSONEstimationResourceActionParams)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actionType";
    }
})(Types_Estimation.tofuJSONTargetComponentAction)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "newResourceId";
    }
})(TofuJSON.readMaybe(Types_Component.tofuJSONEstimationResourceId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "newResourceId";
    }
})(TofuJSON.readMaybe(Types_Component.tofuJSONEstimationResourceId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResourceAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "estimationResourceAction";
    }
}))()()(Types_Route.routeReflectProxy(Types_Estimation.tofuJSONEstimationLocationAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "estimationLocationAction";
    }
}))()()(Types_Route.routeReflectProxy(Types_Estimation.tofuJSONEstimationElementAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementIds";
    }
})(TofuJSON.readArray(Types_Element.tofuJSONElementId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementIds";
    }
})(TofuJSON.readArray(Types_Element.tofuJSONElementId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationElementAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "estimationElementAction";
    }
}))()()(Types_Route.routeReflectProxy(Types_Estimation.tofuJSONEstimationComponentAction)(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentIds";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationComponentAction";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "estimationComponentAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(Types_Component.tofuJSONComponentType)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(Types_Component.tofuJSONComponentType)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/component/convertToTopic";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "convertToTopicComponent";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(Types_Component.tofuJSONComponentType)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(Types_Component.tofuJSONComponentType)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.nilWriteForeignFields)()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/component/convertToRegular";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "convertToRegularComponent";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojectId";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/componentSubprojectUpdate";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentSubprojectMassUpdate";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sourceProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sourceSubprojectId";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sourceProjectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sourceSubprojectId";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/componentPriceMassUpdate";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentPriceMassUpdate";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/componentPriceMassDelete";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentPriceMassDelete";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/componentGroupsMassDelete";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentGroupsMassDelete";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/toggleFlagForComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentFlagMassUpdate";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "components";
    }
})(TofuJSON.readArray(Types_Component.tofuJSONComponentId))(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/toggleCheckedForComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "componentCheckMassUpdate";
    }
})));
var estimationResourcesRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResources";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationResourcesRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONComponentId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isCostClassPrice";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "multiplier";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readNullable(TofuJSON.readInt))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceListId";
    }
})(TofuJSON.readNullable(Types_Component.tofuJSONOrgEstimationResourceId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "pricePerUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONProjectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxPercentage";
    }
})(Types_Unit.tofuJSONTaxrate)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unitConsumptionRate";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "usagesCount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "wastePercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResources";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationResourcePriceListRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "changeDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "contract";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONCostClassCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currencyId";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "discountPercentage";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "eanCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "index";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "orgResourcePriceId";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "ownCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "price";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceListId";
    }
})(Types_Component.tofuJSONOrgEstimationResourceId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "priceWithDiscount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceClassificationGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sortingNumber";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "taxRate";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "user";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "validDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendor";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorBatchSize";
    }
})(TofuJSON.readNullable(TofuJSON.readNumber))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "vendorUnit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationResourcePriceList";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationProjectSummariesRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/estimationProjects";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet);
var estimationProjectSummariesRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "applicationMode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_Project.tofuJSONProjectCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createdDate";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "currency";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "isReportingProject";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "programType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectGroup";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "state";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subprojects";
    }
})(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsNil)()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "countInMeasurementTotal";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Project.tofuJSONSubprojectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "version";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/estimationProjects";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet);
var estimationLocationsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationLocationsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amountSource";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "createTime";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "elementSpecId";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONElementSpecId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationLocationId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "locationCode";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "sourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "userName";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amountSource";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "createTime";
    }
})(TofuJSON.readNullable(Types_JSDateString.tofuJSONJSDateString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "elementSpecId";
    }
})(TofuJSON.readNullable(Types_Newtypes.tofuJSONElementSpecId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimationComponentId";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONEstimationLocationId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "locationCode";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "sourceApplication";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "userName";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationElementsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/elements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationElementsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElement))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elements";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationComponentsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var estimationComponentsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "amount";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "checked";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "classCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "componentType";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupDescription";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "description";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "flagged";
    }
})(TofuJSON.readBoolean)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "group";
    }
})(TofuJSON.readNullable(Types_ClassificationGroup.tofuJSONClassificationGroupCode))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_Component.tofuJSONComponentId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectCode";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectId";
    }
})(TofuJSON.readNullable(Types_Project.tofuJSONSubprojectId))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "subProjectName";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "unit";
    }
})(TofuJSON.readNullable(TofuJSON.readString))(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/estimationComponents";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var elementSpecsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementSpecs";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var elementSpecsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElementSpec))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementSpecs";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var elementMeasuresRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONElementMeasure))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementMeasures";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var elementLocationsRouteForeign = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.tofuJSONForeign)({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var elementLocationsRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_Element.tofuJSONWasmElementLocation))({
    reflectSymbol: function () {
        return "/api/project/:projectId/elementLocations";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet);
var costGroupRoutes = Naporitan.reflectRecordProxy(Naporitan.reflectRecordProxyInst()(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderConsRoute(Naporitan.reflectRecordProxyBuilderNil)()()(Types_Route.routeReflectProxy(Types_CostGroup.tofuJSONVATExclusionCostGroupsAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/vatExclusionCostGroupsActionRoute";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "vatExclusionCostGroupsAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(Types_CostGroup.tofuJSONVATExclusionCostGroups)({
    reflectSymbol: function () {
        return "/api/project/:projectId/VATExclusionCostGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "vatExclusionCostGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "oldCostGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "resourceIds";
    }
})(TofuJSON.readArray(Types_CostGroup.tofuJSONResourceId))(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "oldCostGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "resourceIds";
    }
})(TofuJSON.readArray(Types_CostGroup.tofuJSONResourceId))(TofuJSON.nilWriteForeignFields)()()())()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/updateReportingResourceCostGroupCode";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateReportingResourceCostGroupCode";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroup/:costGroupId/updateMemo";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costGroupId";
    }
})(Types_CostGroup.writeParamCostGroupId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateCostGroupMemo";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "value";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroup/:costGroupId/completionPercentage";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costGroupId";
    }
})(Types_CostGroup.writeParamCostGroupId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateCostGroupCompletionPercentage";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCategory";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCategory";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.nilWriteForeignFields)()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroup/:costGroupId/category";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "costGroupId";
    }
})(Types_CostGroup.writeParamCostGroupId)(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil)))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "updateCostGroupCategory";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readObject(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONMainCostGroupId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONMainCostGroupId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/mainCostGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "mainCostGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "mainCostGroupId";
    }
})(Types_CostGroup.tofuJSONMainCostGroupId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "mainCostGroupId";
    }
})(Types_CostGroup.tofuJSONMainCostGroupId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/mainCostGroupName";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "editMainCostGroupNames";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costGroupCode";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroupName";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "editCostGroupNames";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readArray(Types_CostGroup.tofuJSONCostGroupCode))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodDelete))({
    reflectSymbol: function () {
        return "deleteCostGroups";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "category";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "completionPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "category";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "completionPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costClassCode";
    }
})(Types_Newtypes.tofuJSONCostClassCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroups/costClassItems";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroupsCostClassItems";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "actualSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "category";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "completionPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "estimatedSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "targetSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.readFieldsNil)()())()())()())()())()())()())()())()())()())()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "actualSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "category";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "completionPercentage";
    }
})(Types_Unit.tofuJSONPercentageOfHundred)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "estimatedSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(Types_CostGroup.tofuJSONCostGroupId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "memo";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.tofuJSONProjectId)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetCosts";
    }
})(TofuJSON.readNumber)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "targetSocialExpenses";
    }
})(TofuJSON.readNumber)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroups";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroups";
    }
}))()()(Types_Route.routeReflectProxy(Types_CostGroup.tofuJSONCostGroupItemAction)(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroupItem";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "costGroupItemAction";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(Types_CostGroup.tofuJSONCostGroupInfo))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroupInfos";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroupInfos";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readArray(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "place";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSON)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "id";
    }
})(TofuJSON.readInt)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "place";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()())()()())()()())))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroupCategories";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodGet))({
    reflectSymbol: function () {
        return "costGroupCategories";
    }
}))()()(Types_Route.routeReflectProxy(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.readFieldsNil)()())()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "code";
    }
})(Types_CostGroup.tofuJSONCostGroupCode)(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "name";
    }
})(TofuJSON.readString)(TofuJSON.nilWriteForeignFields)()()())()()()))(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))({
    reflectSymbol: function () {
        return "/api/project/:projectId/costGroup";
    }
})()(Types_Route.formatURLCons()({
    reflectSymbol: function () {
        return "projectId";
    }
})(Types_Project.writeParamProjectId)(Types_Route.formatURLNil))(Types_Route.getRequestMethodPost))({
    reflectSymbol: function () {
        return "addCostGroup";
    }
})));
var costControlExcludeActualCostSocialExpensesRoute = Types_Route.mkRoute(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))(TofuJSON.readRecord()(TofuJSON.readFieldsCons({
    reflectSymbol: function () {
        return "costControlExcludeActualCostSocialExpenses";
    }
})(TofuJSON.readBoolean)(TofuJSON.readFieldsNil)()())(TofuJSON.consWriteForeignFields({
    reflectSymbol: function () {
        return "costControlExcludeActualCostSocialExpenses";
    }
})(TofuJSON.readBoolean)(TofuJSON.nilWriteForeignFields)()()()))({
    reflectSymbol: function () {
        return "/api/costControlExcludeActualCostSocialExpenses";
    }
})()(Types_Route.formatURLNil)(Types_Route.getRequestMethodGet);
module.exports = {
    serverRoutes: serverRoutes,
    projectRoutes: projectRoutes,
    costGroupRoutes: costGroupRoutes,
    incomeRoutes: incomeRoutes,
    invoiceRoutes: invoiceRoutes,
    estimationRoutes: estimationRoutes,
    offerRoutes: offerRoutes,
    planningRoutes: planningRoutes,
    estimationProjectSummariesRoute: estimationProjectSummariesRoute,
    estimationProjectSummariesRouteForeign: estimationProjectSummariesRouteForeign,
    invoicesRoute: invoicesRoute,
    subprojectsRoute: subprojectsRoute,
    subprojectsRouteForeign: subprojectsRouteForeign,
    referenceSubprojectsRoute: referenceSubprojectsRoute,
    referenceSubprojectsRouteForeign: referenceSubprojectsRouteForeign,
    estimationComponentsRoute: estimationComponentsRoute,
    estimationComponentsRouteForeign: estimationComponentsRouteForeign,
    referenceEstimationComponentsRoute: referenceEstimationComponentsRoute,
    referenceEstimationComponentsRouteForeign: referenceEstimationComponentsRouteForeign,
    referenceEstimationElementsRouteForeign: referenceEstimationElementsRouteForeign,
    referenceEstimationElementsRoute: referenceEstimationElementsRoute,
    estimationResourcesRoute: estimationResourcesRoute,
    estimationResourcesRouteForeign: estimationResourcesRouteForeign,
    estimationResourcePriceListRoute: estimationResourcePriceListRoute,
    referenceEstimationResourcesRoute: referenceEstimationResourcesRoute,
    referenceEstimationResourcesRouteForeign: referenceEstimationResourcesRouteForeign,
    referenceEstimationLocationsRoute: referenceEstimationLocationsRoute,
    referenceEstimationLocationsRouteForeign: referenceEstimationLocationsRouteForeign,
    estimationLocationsRoute: estimationLocationsRoute,
    estimationLocationsRouteForeign: estimationLocationsRouteForeign,
    estimationElementsRouteForeign: estimationElementsRouteForeign,
    estimationElementsRoute: estimationElementsRoute,
    elementLocationsRouteForeign: elementLocationsRouteForeign,
    elementLocationsRoute: elementLocationsRoute,
    referenceElementLocationsRouteForeign: referenceElementLocationsRouteForeign,
    referenceElementLocationsRoute: referenceElementLocationsRoute,
    elementMeasuresRoute: elementMeasuresRoute,
    elementSpecsRouteForeign: elementSpecsRouteForeign,
    elementSpecsRoute: elementSpecsRoute,
    referenceElementSpecsRouteForeign: referenceElementSpecsRouteForeign,
    referenceElementSpecsRoute: referenceElementSpecsRoute,
    costControlExcludeActualCostSocialExpensesRoute: costControlExcludeActualCostSocialExpensesRoute,
    planningCostGroupsRoute: planningCostGroupsRoute,
    planningCostGroupsRouteForeign: planningCostGroupsRouteForeign,
    organizationAdminInfoRoute: organizationAdminInfoRoute,
    setUserSSOLoginRoute: setUserSSOLoginRoute,
    exportProjectToFileRoute: exportProjectToFileRoute,
    serverStatus: serverStatus
};
